import { render, staticRenderFns } from "./detailsPage-withoutFooter.vue?vue&type=template&id=9562e7ea&scoped=true"
import script from "./detailsPage-withoutFooter.vue?vue&type=script&lang=js"
export * from "./detailsPage-withoutFooter.vue?vue&type=script&lang=js"
import style0 from "./detailsPage-withoutFooter.vue?vue&type=style&index=0&id=9562e7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9562e7ea",
  null
  
)

export default component.exports